import React from "react";
import {
  CustomBadge,
  CustomCopyToClipboard,
} from "../../../../../../Components";
import { Box } from "@material-ui/core";
import { format } from "date-fns";
import { DotIcon } from "../../../../../../assets/icons";

export const OfferTrackingTableHeaderData = (styles, palette) => [
  {
    id: 1,
    formFieldId: 1,
    minWidth: 124,
    headerName: "Offer ID",
    field: "vendorOfferId",
    fieldKey: "vendorOfferId",
    displayPath: "vendorOfferId",
    isHiddenFilter: true,
    sortable: false,
    filterable: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    disableColumnMenu: true,
    formFieldTitle: "vendorOfferId",
    searchKey: "vendorOfferId",
    renderCell: (item) => {
      return (
        <CustomCopyToClipboard
          data={item?.row?.vendorOfferId} // copy
          childrenData={"#" + item?.row?.vendorOfferId} // render
          copyDoneShowTime={1000}
        />
      );
    },
  },
  {
    id: 2,
    formFieldId: 2,
    minWidth: 132,
    headerName: "Vendor offer",
    field: "vendorOfferName",
    fieldKey: "vendorOfferName",
    displayPath: "vendorOfferName",
    isHiddenFilter: true,
    sortable: false,
    filterable: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    disableColumnMenu: true,
    formFieldTitle: "vendorOfferName",
    searchKey: "vendorOfferName",
    renderCell: (item) => {
      return (
        <Box className={styles.vendorNameTitle}>
          {item?.row?.vendorOfferName || 'N/A'}
        </Box>
      );
    },
  },
  {
    id: 3,
    formFieldId: 3,
    minWidth: 162,
    headerName: "Service category",
    field: "vendorServiceCategoryName",
    fieldKey: "vendorServiceCategoryName",
    displayPath: "vendorServiceCategoryName",
    isHiddenFilter: true,
    sortable: false,
    filterable: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    disableColumnMenu: true,
    formFieldTitle: "vendorServiceCategoryName",
    searchKey: "vendorServiceCategoryName",
    renderCell: (item) => {
      return (
        <Box className={styles.vendorNameTitle}>
          {item?.row?.vendorServiceCategoryName || 'N/A'}
        </Box>
      );
    },
  },
  {
    id: 4,
    formFieldId: 4,
    minWidth: 246,
    headerName: "Vendor name",
    field: "vendorName",
    fieldKey: "vendorName",
    displayPath: "vendorName",
    isHiddenFilter: true,
    sortable: false,
    filterable: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    disableColumnMenu: true,
    formFieldTitle: "vendorName",
    searchKey: "vendorName",
    renderCell: (item) => {
      return (
        <Box className={styles.vendorNameTitle}>{item?.row?.vendorName ||'N/A'}</Box>
      );
    },
  },
  {
    id: 5,
    formFieldId: 5,
    minWidth: 114,
    headerName: "Vendor ID",
    field: "vendorId",
    fieldKey: "vendorId",
    displayPath: "vendorId",
    isHiddenFilter: true,
    sortable: false,
    filterable: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    disableColumnMenu: true,
    formFieldTitle: "vendorId",
    searchKey: "vendorId",
    renderCell: (item) => {
      return (
        <Box className={styles.vendorNameTitle}>#{item?.row?.vendorId || 'N/A'}</Box>
      );
    },
  },
  {
    id: 6,
    formFieldId: 6,
    minWidth: 190,
    headerName: "Date of interest",
    field: "createdOn",
    isHiddenFilter: false,
    filterable: true,
    disableColumnMenu: true,
    fieldType: "datePicker",
    displayPath: "createdOn",
    isDate: true,
    sortable: true,
    isDefaultFilterColumn: true,
    fieldKey: "createdOn",
    formFieldTitle: "Creation On",

    renderCell: (item) => {
      const createdOn = item?.row?.createdOn;
      const date = createdOn ? new Date(createdOn) : null;

      return (
        <Box className={styles.vendorNameTitle}>
          {date ? (
            <Box className={styles.containerDate}>
              <Box>{format(date, "dd MMM yyyy")}</Box>
              <Box>{format(date, "hh:mm a")}</Box>
            </Box>
          ) : (
            "N/A"
          )}
        </Box>
      );
    },
  },
  {
    id: 7,
    formFieldId: 7,
    minWidth: 137,
    headerName: "Offer status",
    field: "offerStatus",
    fieldKey: "offerStatus",
    displayPath: "offerStatus",
    isHiddenFilter: true,
    sortable: false,
    filterable: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    disableColumnMenu: true,
    formFieldTitle: "offerStatus",
    searchKey: "offerStatus",
    renderCell: (item) => {
      return (
        <CustomBadge
          label={item?.row?.offerStatus}
          Color={
            item?.row?.offerStatus === "Active"
              ? palette.utility.success_700
              : item?.row?.offerStatus === "Inactive"
              ? palette.utility.error_700
              // : item?.row?.offerStatus === "Pending"
              // ? palette.utility.orange_700
              : palette.utility.success_700
          }
          LeftIcon={
            <DotIcon
              width="8"
              height="8"
              fill={
                item?.row?.offerStatus === "Active"
                  ? palette.utility.success_500
                  : item?.row?.offerStatus === "Inactive"
                  ? palette.utility.error_500
                  // : item?.row?.offerStatus === "Pending"
                  // ? palette.utility.orange_500
                  : palette.utility.success_700
              }
            />
          }
          SizeVariant={"medium"}
        ></CustomBadge>
      );
    },
  },
  {
    id: 8,
    formFieldId: 8,
    minWidth: 129,
    headerName: "Promo code",
    field: "promoCode",
    fieldKey: "promoCode",
    displayPath: "promoCode",
    isHiddenFilter: true,
    sortable: false,
    filterable: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    disableColumnMenu: true,
    formFieldTitle: "promoCode",
    searchKey: "promoCode",
    renderCell: (item) => {
      return (
        <CustomCopyToClipboard
          data={item?.row?.promoCode} // copy
          childrenData={"#" + item?.row?.promoCode} // render
          copyDoneShowTime={1000}
        />
      );
    },
  },
  {
    id: 9,
    formFieldId: 9,
    minWidth: 188,
    headerName: "Discount percentage",
    field: "discountPercentage",
    fieldKey: "discountPercentage",
    displayPath: "discountPercentage",
    isHiddenFilter: true,
    sortable: false,
    filterable: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    disableColumnMenu: true,
    formFieldTitle: "discountPercentage",
    searchKey: "discountPercentage",
    renderCell: (item) => {
      return (
        <Box className={styles.vendorNameTitle}>
          {item?.row?.discountPercentage || "N/A"}
        </Box>
      );
    },
  },
  {
    id: 10,
    formFieldId: 10,
    minWidth: 156,
    headerName: "PSI Commission",
    field: "psiCommissionPercentage",
    fieldKey: "psiCommissionPercentage",
    displayPath: "psiCommissionPercentage",
    isHiddenFilter: true,
    sortable: false,
    filterable: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    disableColumnMenu: true,
    formFieldTitle: "psiCommissionPercentage",
    searchKey: "psiCommissionPercentage",
    renderCell: (item) => {
      return (
        <Box className={styles.vendorNameTitle}>
          {item?.row?.psiCommissionPercentage || "N/A"}
        </Box>
      );
    },
  },
];
